import {DreRowEntity} from "../../../../domain/entity/dre-row.entity";

export function dreRowNameFormatter(row: DreRowEntity, parentRow?: DreRowEntity) : string {
    if (parentRow) {
        return `${parentRow.order}.${row.order} - ${row.name}`;
    }

    return `${row.order} - ${row.name}`;
}